import React, { useEffect, useRef, useState } from 'react'
import { Accordion, Col, Container, Row } from 'react-bootstrap'
import { PrintingListVM } from '../../Structure/ViewModels/Printing/PrintingListVM'
import { Globals } from '../../Structure/Globals/GlobalObs'
import Input from 'react-select/dist/declarations/src/components/Input'
import Search from '../Utilities/Search'
import CustomSelect from '../Utilities/CustomSelect'

const PrintingList = () => {
    const [vm, setVm] = useState<{viewModel:PrintingListVM}>({viewModel:new PrintingListVM()})
    const control = vm.viewModel
    useEffect(()=>{
      control.subscribeUpdate(setVm)
      control.getData()
    },[])

    useEffect(() => {
      const handleScroll = () => {
          const elementCourses = scrollableRefCourses.current;
          if (elementCourses && elementCourses.scrollTop + elementCourses.clientHeight +10 >= elementCourses.scrollHeight) {
            control.addCourses()
          }
      };
  
      const elementCourses = scrollableRefCourses.current;
      if (elementCourses) {
          elementCourses.addEventListener('scroll', handleScroll);
      }
  
      return () => {
          if (elementCourses) {
              elementCourses.removeEventListener('scroll', handleScroll);
          }
      };
  }, []);
  
  useEffect(() => {
    const handleScrollPaths = () => {
        const elementPaths = scrollableRefPaths.current;
        if (elementPaths && elementPaths.scrollTop + elementPaths.clientHeight +10 >= elementPaths.scrollHeight) {
          control.addPaths()
        }
    };
  
    const elementPaths = scrollableRefPaths.current;
    if (elementPaths) {
        elementPaths.addEventListener('scroll', handleScrollPaths);
    }
  
    return () => {
        if (elementPaths) {
            elementPaths.removeEventListener('scroll', handleScrollPaths);
        }
    };
  }, []);
  
  const scrollableRefCourses = useRef<HTMLDivElement | null>(null);
  const scrollableRefPaths = useRef<HTMLDivElement | null>(null);

    useEffect(()=>{
      control.getData()
    },[control.Refreshes])


  return (
    <div className='w-100'>
      {
        control.Show(
          <Container className='w-100'>
      <Row className='p-0 m-0  py-3'>
        <div className='py-4'>
          <button className='button-I btn-cl-I px-5 py-2' onClick={()=>control.certify()}>انشاء الشهادات</button>
        </div>
        <Accordion defaultActiveKey={'0'} className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
          <Accordion.Item eventKey='1' className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}} >
            <Accordion.Button  className='border-0 border-bottom' style={{outline:'none', border:'none' , borderRadius:'0px', boxShadow:'none'}}>
              <h5 className='ps-3 px-2'>المسارات</h5>
            </Accordion.Button>
            <Accordion.Body ref={scrollableRefPaths} className=' d-flex flex-column justify-content-between overflow-y-auto'>
              <Row>
                <div>
                  <Search hasNoSelect onSearch={a=>control.CoursesSearch=a} />
                </div>
              </Row>
              <div  ref={scrollableRefPaths}   className='d-flex flex-wrap justify-content-center  overflow-y-auto' style={{height:'600px'}}>
                {
                  control.Pathes.map((item,index)=>{
                    const Result = ()=>{
                      const [path ,setPath] = useState(item.name)
                      const [trainee_name ,setTraineeName] = useState(item.trainee_name)
                      const [trainee_english_name ,setTraineeEnglishName] = useState(item.trainee_english_name)
                      const [start ,setStart] = useState(item.start)
                      const [end ,setEnd] = useState(item.end)
                      const [hours ,setHours] = useState(item.hours)
                      const [institution ,setInstitution] = useState(item.institution)
                      const [notes,setNotes] = useState('')
                      const [active , setActive] = useState(false)
                      const [verification , setVerification] = useState(item.verification)

                      const confirm = ()=>{
                        control.confirmPath(item.id , item.code ,path , item.trainee_id ,trainee_name, trainee_english_name ,start , end, hours , institution , notes , verification).then((value)=>{setActive(value)})
                      }

                      return (
                        <div key={index} className='p-3'>
                          <div className='border rounded-3 d-flex flex-column overflow-hidden' style={{width:'250px'}}>
                            <div className='p-2 text-center fw-bold text-danger allow-select'>{item.code}</div>

                            <div className='p-2 text-center fw-bold'>
                              {Globals.auth.User?.permissions.some(a=>a.id=='17')?(
                                <textarea style={{resize:'none'}} className='input-field'  disabled={active} value={path} onChange={a=>setPath(a.target.value)}/>
                              ):(path)}
                            </div>
                            <div className='p-2 text-center fw-bold'>
                              {Globals.auth.User?.permissions.some(a=>a.id=='17')?(
                                <textarea style={{resize:'none'}} className='input-field'  disabled={active} value={trainee_name} onChange={a=>setTraineeName(a.target.value)}/>
                              ):(trainee_name)}
                            </div>
                            <div className='p-2 text-center fw-bold'>
                              {Globals.auth.User?.permissions.some(a=>a.id=='17')?(
                                <textarea style={{resize:'none'}} className='input-field'  disabled={active} value={trainee_english_name} onChange={a=>setTraineeEnglishName(a.target.value)}/>
                              ):(trainee_english_name)}
                            </div>
                            <div className='p-2 text-center fw-bold'>من &nbsp;
                                {Globals.auth.User?.permissions.some(a=>a.id=='17')?(
                                  <input type='date' style={{resize:'none'}}  disabled={active} className='input-field' value={start} onChange={a=>setStart(a.target.value)}/>
                                ):(start)}
                            </div>
                            <div className='p-2 text-center fw-bold'>الى &nbsp;
                                {Globals.auth.User?.permissions.some(a=>a.id=='17')?(
                                  <input type='date' style={{resize:'none'}}  disabled={active} className='input-field' value={end} onChange={a=>setEnd(a.target.value)}/>
                                ):(end)}
                            </div>
                            <div className='p-2 text-center fw-bold'>
                                {Globals.auth.User?.permissions.some(a=>a.id=='17')?(
                                  <input type='number' style={{resize:'none'}}  disabled={active} className='input-field w-50' value={hours} onChange={a=>setHours(a.target.value)}/>
                                ):(hours)} &nbsp; ساعة
                              </div>
                              <div className='p-2 text-center fw-bold'>
                              {Globals.auth.User?.permissions.some(a=>a.id=='17')?(
                                <textarea style={{resize:'none'}}  disabled={active} className='input-field' value={institution} onChange={a=>setInstitution(a.target.value)}/>
                              ):(institution)}
                            </div>
                            <div className='p-2 text-center fw-bold mx-auto d-flex justify-content-center'>
                              {Globals.auth.User?.permissions.some(a=>a.id=='17')?(
                                // <textarea style={{resize:'none'}}  disabled={active} className='input-field' value={institution} onChange={a=>setInstitution(a.target.value)}/>
                                active?(verification==='verify'?'توثيق':'بدون توثيق'):(
                                  <CustomSelect list={[{label:'توثيق' , value:'verify'} , {label:'بدون توثيق' , value:'no verify'}]} selected={verification} onSelect={a=>setVerification(a)} />
                                )
                              ):(verification)}
                            </div>
                            <div className='p-2 text-center fw-bold'>
                              <textarea className='input-field' disabled={active} style={{resize:'none'}} placeholder='ملاحظات' value={notes} onChange={a=>setNotes(a.target.value)}></textarea>
                            </div>
                            {
                              Globals.auth.User?.permissions.some(a=>a.id=='27')?(
                                <button style={{visibility:active?'hidden':'visible'}} className='button-I bg-success text-white fw-bold py-2' onClick={confirm} >تم الطباعة</button>
                              ):(null)
                            }
                          </div>
                        </div>
                      )
                    }

                   return (<Result key={index} />)

                })
                }
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion> 
      </Row>
      <Row className='p-0 m-0  py-3'>
        <Accordion defaultActiveKey={'0'} className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
          <Accordion.Item eventKey='1' className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}} >
            <Accordion.Button  className='border-0 border-bottom' style={{outline:'none', border:'none' , borderRadius:'0px', boxShadow:'none'}}>
              <h5 className='ps-3 px-2'>الكورسات</h5>
            </Accordion.Button>
            <Accordion.Body  ref={scrollableRefCourses} className=' d-flex flex-column justify-content-between'>
            <Row>
                <div>
                  <Search hasNoSelect onSearch={a=>control.CoursesSearch=a} />
                </div>
              </Row>
            <div  ref={scrollableRefCourses}  className='d-flex flex-wrap justify-content-center  overflow-y-auto'  style={{height:'600px'}}>
                {
                  control.Courses.map((item,index)=>{
                    const Result = ()=>{
                      const [name ,setName] = useState(item.name)
                      const [trainee_name ,setTraineeName] = useState(item.trainee_name)
                      const [trainee_english_name ,setTraineeEnglishName] = useState(item.trainee_english_name)
                      const [start ,setStart] = useState(item.start)
                      const [end ,setEnd] = useState(item.end)
                      const [hours ,setHours] = useState(item.hours)
                      const [institution ,setInstitution] = useState(item.institution)
                      const [notes,setNotes] = useState('')
                      const [active , setActive] = useState(false)

                      const confirm = ()=>{
                        control.confirmCourse(item.id , item.code ,name , item.specialization , item.trainee_id ,trainee_name , trainee_english_name ,start , end, hours , institution , notes).then((value)=>{setActive(value)})
                      }

                      return (
                        <div key={index} className='p-3'>
                          <div className='border rounded-3 d-flex flex-column overflow-hidden' style={{width:'250px'}}>
                            <div className='p-2 text-center fw-bold text-danger allow-select'>{item.code}</div>

                            <div className='p-2 text-center fw-bold'>
                              {Globals.auth.User?.permissions.some(a=>a.id=='17')?(
                                <textarea style={{resize:'none'}} className='input-field'  disabled={active} value={name} onChange={a=>setName(a.target.value)}/>
                              ):(name)}
                            </div>
                            <div className='p-2 text-center fw-bold'>
                              {Globals.auth.User?.permissions.some(a=>a.id=='17')?(
                                <textarea style={{resize:'none'}} className='input-field'  disabled={active} value={trainee_name} onChange={a=>setTraineeName(a.target.value)}/>
                              ):(trainee_name)}
                            </div>
                            <div className='p-2 text-center fw-bold'>
                              {Globals.auth.User?.permissions.some(a=>a.id=='17')?(
                                <textarea style={{resize:'none'}} className='input-field'  disabled={active} value={trainee_english_name} onChange={a=>setTraineeEnglishName(a.target.value)}/>
                              ):(trainee_english_name)}
                            </div>
                            <div className='p-2 text-center fw-bold'>من &nbsp;
                                {Globals.auth.User?.permissions.some(a=>a.id=='17')?(
                                  <input type='date' style={{resize:'none'}}  disabled={active} className='input-field' value={start} onChange={a=>setStart(a.target.value)}/>
                                ):(start)}
                            </div>
                            <div className='p-2 text-center fw-bold'>الى &nbsp;
                                {Globals.auth.User?.permissions.some(a=>a.id=='17')?(
                                  <input type='date' style={{resize:'none'}}  disabled={active} className='input-field' value={end} onChange={a=>setEnd(a.target.value)}/>
                                ):(end)}
                            </div>
                            <div className='p-2 text-center fw-bold'>
                                {Globals.auth.User?.permissions.some(a=>a.id=='17')?(
                                  <input type='number' style={{resize:'none'}}  disabled={active} className='input-field w-50' value={hours} onChange={a=>setHours(a.target.value)}/>
                                ):(hours)} &nbsp; ساعة
                              </div>
                              <div className='p-2 text-center fw-bold'>
                              {Globals.auth.User?.permissions.some(a=>a.id=='17')?(
                                <textarea style={{resize:'none'}}  disabled={active} className='input-field' value={institution} onChange={a=>setInstitution(a.target.value)}/>
                              ):(institution)}
                            </div>
                            <div className='p-2 text-center fw-bold'>
                              <textarea className='input-field' disabled={active} style={{resize:'none'}} placeholder='ملاحظات' value={notes} onChange={a=>setNotes(a.target.value)}></textarea>
                            </div>
                            {
                              Globals.auth.User?.permissions.some(a=>a.id=='27')?(
                                <button style={{visibility:active?'hidden':'visible'}} className='button-I bg-success text-white fw-bold py-2' onClick={confirm} >تم الطباعة</button>
                              ):(null)
                            }
                          </div>
                        </div>
                      )
                    }

                   return (<Result key={index} />)

                })}
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion> 
      </Row>
      </Container>)
      }
    </div>
  )
}

export default PrintingList
